<div class="row actions">
  @if (visible) {
  <div class="col-1 btn-group p-0">
    <button (click)="deleteAssessment()" class="btn btn-outline-danger btn-sm">
      <span class="material-symbols-outlined pt-1"> delete </span>
    </button>
  </div>
  }
</div>
<div class="table-responsive mt-2">
  <table aria-label="group-assessments-table" class="table table-hover table-bordered">
    <thead>
      <tr>
        <!-- Checkbox Column -->
        <th class="align-middle" scope="col" style="width: 3%">
          <mat-checkbox
            (change)="$event ? masterToggle() : null"
            [checked]="allIsSelected"
            [indeterminate]="selectedGroupAssessments.length !== 0 && !allIsSelected" />
        </th>
        <!--  type Column -->
        <th class="align-middle assessment-type" scope="col">
          <strong>Type</strong>
        </th>
        <!--  Description Column -->
        <th class="align-middle assessment-description" scope="col">
          <strong>Description</strong>
        </th>
        <!--  Advancement Column -->
        <th
          class="align-middle assessment-advancement"
          scope="col"
          matTooltip="Nombre de candidats ayant réussi sur le nombre total de candidats">
          <strong>Avancement</strong>
          <span class="material-symbols-outlined align-middle fs-5 text-primary p-1 ms-1"> info </span>
        </th>
        <th
          class="align-middle assessment-expiration-date"
          scope="col"
          matTooltip="Date à laquelle le questionnaire ne sera plus accessible">
          <strong>Date d'expiration</strong>
          <span class="material-symbols-outlined align-middle fs-5 text-primary p-1 ms-1"> info </span>
        </th>
        <!--  Download Column -->
        <th class="align-middle assessment-export" scope="col">
          <strong>Exporter</strong>
        </th>
      </tr>
    </thead>
    <tbody>
      @for (groupAssessment of groupAssessmentsPage().content; track groupAssessment) {
      <tr class="table-row" [routerLink]="['/groupStats/', groupAssessment.groupId]">
        <td>
          <mat-checkbox
            (change)="boxChecked(groupAssessment)"
            [checked]="selectedGroupAssessments.includes(groupAssessment)"
            (click)="$event.stopPropagation()" />
        </td>
        <td>
          {{ groupAssessment.assessmentName }}
          @if (groupAssessment.assessmentIsCertifying) {
          <syn-certified-assessment-icon />
          }
        </td>
        <td>{{ groupAssessment.description }}</td>
        <td>{{ groupAssessment.advancement }}</td>
        <td class="no-link-effect" (click)="$event.stopPropagation()">
          <mat-form-field subscriptSizing="dynamic">
            <input
              matInput
              [min]="minDate"
              [matDatepicker]="datepicker"
              [(ngModel)]="groupAssessment.expirationDate"
              (dateChange)="changeExpirationDate(groupAssessment.groupId, groupAssessment.id, $event.value)" />
            <mat-datepicker #datepicker />
            <mat-datepicker-toggle [for]="datepicker" matSuffix />
          </mat-form-field>
        </td>
        <td class="d-flex justify-content-center border-top-0 border-bottom-0 border-start-0">
          <button
            class="btn btn-outline-primary align-items-center btn-sm"
            (click)="downloadCSV(groupAssessment.id, groupAssessment.groupId, groupAssessment.assessmentName)"
            matTooltip="Exporter les résultats du questionnaire au format CSV">
            <span class="material-symbols-outlined pt-1"> file_download </span>
          </button>
        </td>
      </tr>
      }
    </tbody>
  </table>
</div>
